import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";

/**
 * A custom hook to manage the state of `ResourceFormModal` in `ResourcesSection`.
 *
 * @returns An object containing:
 *   - `disclosure`: An object with modal control functions (i.e. `onOpen`, `onClose`, etc)
 *   - `onOpenResource`: A function to set the slug for the resource and open the modal.
 *   - `slug`: The selected resource identifier.
 */
export default function useResourceControl() {
  const [slug, setSlug] = useState<string>("");
  const disclosure = useDisclosure();
  const onOpenResource = (slug: string) => {
    setSlug(slug);
    disclosure.onOpen();
  };

  return { disclosure, onOpenResource, slug };
}
